import React, { createContext, useContext, useMemo, useState } from 'react';

export type MasterAdminShellBranding = {
  imageUrl?: string;
  primary: string;
} | null;

type MasterAdminShellBrandingContextValue = {
  branding: MasterAdminShellBranding;
  setBranding: React.Dispatch<React.SetStateAction<MasterAdminShellBranding>>;
};

const MasterAdminShellBrandingContext = createContext<MasterAdminShellBrandingContextValue | undefined>(
  undefined
);

export const MasterAdminShellBrandingProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [branding, setBranding] = useState<MasterAdminShellBranding>(null);
  const value = useMemo(() => ({ branding, setBranding }), [branding]);

  return React.createElement(MasterAdminShellBrandingContext.Provider, { value }, children);
};

export function useMasterAdminShellBranding(): MasterAdminShellBrandingContextValue {
  const ctx = useContext(MasterAdminShellBrandingContext);
  if (!ctx) {
    throw new Error('useMasterAdminShellBranding must be used within MasterAdminShellBrandingProvider');
  }
  return ctx;
}
